import { getGoodsFormsListData, getGoodsAspectsListData, getGoodsSpaListData, getGoodsPaListData, getBasfProductList, getTagList, getFormulationList, getLastUpdateTime, getRecommendProduct, getTop10Product, getPhaseList } from '@/axios/api/formulationClient'
import { getSearchByLetterListData } from '@/axios/api/consumerProducts'
import { url } from '@/axios/api_urls/formulation'
import $axios from '@/axios/config.js'
const UPDATE_GOODSFORMLISTDATA = 'UPDATE_GOODSFORMLISTDATA'
const UPDATE_GOODSASPECTSLISTDATA = 'UPDATE_GOODSASPECTSLISTDATA'
const UPDATE_GOODSSPALISTDATA = 'UPDATE_GOODSSPALISTDATA'
const UPDATE_GOODSPALISTDATA = 'UPDATE_GOODSPALISTDATA'
const UPDATE_LIST_DATA = 'UPDATE_LIST_DATA'
const UPDATE_LIST_TOTAL = 'UPDATE_LIST_TOTAL'
const UPDATE_RECOMMENT_PRODUCT = 'UPDATE_RECOMMENT_PRODUCT'
const UPDATE_SEARCH_CLAIM_LIST = 'UPDATE_SEARCH_CLAIM_LIST'
const state = {
  goodsFormListData: [],
  goodsAspectsListData: [],
  goodsSpaListData: [],
  goodsPaListData: [],
  listData: [],
  listTotal: 0,
  recommendProduct: [],
  searchedClaimList: [],
}
const getters = {
  goodsFormListData: state => state.goodsFormListData,
  goodsAspectsListData: state => state.goodsAspectsListData,
  goodsSpaListData: state => state.goodsSpaListData,
  goodsPaListData: state => state.goodsPaListData,
  listData: state => state.listData.map(v => {
    return {
      ...v,
      viewNum: v.hitNum,
      coverImg: v.imageSrc,
      locations: v.releaseRegionIdsName,
      desc: v.description
    }
  }),
  listTotal: state => state.listTotal,
  recommendProduct: state => state.recommendProduct,
  searchedClaimList: state => state.searchedClaimList
}
const mutations = {
  [UPDATE_GOODSFORMLISTDATA] (state, goodsFormListData) {
    state.goodsFormListData = goodsFormListData
  },
  [UPDATE_GOODSASPECTSLISTDATA] (state, goodsAspectsListData) {
    state.goodsAspectsListData = goodsAspectsListData
  },
  [UPDATE_GOODSSPALISTDATA] (state, goodsSpaListData) {
    state.goodsSpaListData = goodsSpaListData
  },
  [UPDATE_GOODSPALISTDATA] (state, goodsPaListData) {
    state.goodsPaListData = goodsPaListData
  },
  [UPDATE_LIST_DATA] (state, data) {
    state.listData = data
  },
  [UPDATE_LIST_TOTAL] (state, data) {
    state.listTotal = data
  },
  [UPDATE_RECOMMENT_PRODUCT] (state, recommendProduct) {
    state.recommendProduct = recommendProduct
  },
  [UPDATE_SEARCH_CLAIM_LIST] (state, searchedClaimList) {
    state.searchedClaimList = searchedClaimList
  }
}
const actions = {
  // 请求页面头部信息
  async getLastUpdateTimeApi ({ state, commit }, params) {
    try {
      let { data: res } = await getLastUpdateTime({...params})
      return res
    } catch (e) {
      return {}
    }
  },
  async goodsFormListDataApi ({ commit }) {
    try {
      let { data: res } = await getGoodsFormsListData()
      commit(UPDATE_GOODSFORMLISTDATA, res || [])
    } catch (e) { }
  },
  async getGoodsAspectsListDataApi ({ commit }) {
    try {
      let { data: res } = await getGoodsAspectsListData()
      commit(UPDATE_GOODSASPECTSLISTDATA, res || [])
    } catch (e) { }
  },
  async getGoodsSpaListDataApi ({ commit }) {
    try {
      let { data: res } = await getGoodsSpaListData()
      commit(UPDATE_GOODSSPALISTDATA, res || [])
    } catch (e) { }
  },
  async getGoodsPaListDataApi ({ commit }) {
    try {
      let { data: res } = await getGoodsPaListData()
      commit(UPDATE_GOODSPALISTDATA, res || [])
    } catch (e) { }
  },
  async getBasfProductListApi ({ commit }, params) {
    try {
      let { data: res } = await getBasfProductList(params)
      return res
    } catch (e) { }
  },
  async getTagListApi ({ commit }, params) {
    try {
      let { data: res } = await getTagList(params)
      return res
    } catch (e) { }
  },
  async getFormulationListApi ({ commit }, params) {
    try {
      let { data: { list, total } } = await getFormulationList(params)
      commit(UPDATE_LIST_DATA, list || [])
      commit(UPDATE_LIST_TOTAL, total || 0)
      return list
    } catch (e) { }
  },
  async getRecommendProductApi ({ commit }, params) {
    try {
      let { data: res } = await getRecommendProduct(params)
      commit(UPDATE_RECOMMENT_PRODUCT, res || [])
      return res
    } catch (e) { }
  },
  async getTop10ProductApi ({ commit }, params) {
    try {
      let { data: res } = await getTop10Product(params)
      return res || []
    } catch (e) { }
  },
  async getPhaseListApi ({ commit }, params) {
    try {
      let { data: res } = await getPhaseList(params)
      return res || []
    } catch (e) { }
  },
  download ({ commit }, params) {
    return $axios({
      url: url.download,
      method: 'get',
      params,
      responseType: 'arraybuffer'
    })
  },
  // 获取宣称
  async searchClaimDataByTitleApi ({ commit }, params) {
    try {
      const { data: res } = await getSearchByLetterListData({title: params, tname: 'goods'})
      commit(UPDATE_SEARCH_CLAIM_LIST, (res || []).map(v => {
        return {
          id: v.id,
          title: v.title
        }
      }))
    } catch (e) {
      commit(UPDATE_SEARCH_CLAIM_LIST, [])
    }
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/formulationClient.js